module.exports = "/layout/docs/images/algolia-powered-by.0f0dae94.svg";